import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ConnectionService } from '../connection.service';

@Injectable({
  providedIn: 'root'
})
export class AuthguardGuard implements CanActivate {
  constructor(private router: Router, private conn: ConnectionService) { }
  canActivate() {
    if (!this.conn.getEmail()) {
      this.router.navigate(["/login"]);
    }
    if(localStorage.getItem('isLogin') && localStorage.getItem('Sastana_Token') == null){
      this.router.navigate(["/login"]);
    }
    return this.conn.getEmail();
  }
}
